let subscribers = {};

function subscribe(eventName, callback) {
  if (subscribers[eventName] === undefined) {
    subscribers[eventName] = [];
  }

  subscribers[eventName] = [...subscribers[eventName], callback];

  return function unsubscribe() {
    subscribers[eventName] = subscribers[eventName].filter((cb) => {
      return cb !== callback;
    });
  };
}

function publish(eventName, data) {
  if (subscribers[eventName]) {
    // Isolate subscribers: a throw in one must never reject the publisher's promise
    // chain (that is exactly how a PDP error broke the cart drawer's quantity update).
    const promises = subscribers[eventName].map((callback) => {
      try {
        return callback(data);
      } catch (error) {
        console.error(`[pubsub] subscriber for "${eventName}" failed`, error);
        return undefined;
      }
    });
    return Promise.all(promises);
  } else {
    return Promise.resolve()
  }
}
